<div class="modal-header border-bottom-0" ngbAutofocus>
  <strong class="modal-title">
    @if (type == 'info') {
      <i class="bi bi-patch-question mr-2"></i>
    } @else if (type == 'warning') {
      <i class="bi bi-patch-exclamation-fill text-warning mr-2"></i>
    } @else {
      <i class="bi bi-patch-exclamation mr-2"></i>
    }
    {{ title }}
  </strong>
</div>
<div class="modal-body">
  @if (isInnerHTML) {
    <div [innerHTML]="content"></div>
  } @else if (!isInnerHTML) {
    <p class="mb-0">{{ content }}</p>
  }
</div>
<div class="modal-footer">
  <div class="row">
    <div class="col-12 text-end px-3">
      <button type="button" class="btn btn-outline-secondary" (click)=" emit(); this.activeModal.close(false);">ปิด</button>
    </div>
  </div>
</div>
